import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';

export const axiosApi = axios.create({
  baseURL: BASE_URL,
});

export const handleAxiosResponse = response => {
  if (response.status >= 400) {
    const data = response.data;
    let e = new Error();
    e = Object.assign(e, data);
    throw e;
  }
  return response.data;
};
